var $a9b740b7d23548d0$exports = {};
$a9b740b7d23548d0$exports = {
  "pending": "\uBCF4\uB958 \uC911"
};
export { $a9b740b7d23548d0$exports as default };